/**
 * Keep notification and system-message clicks on this site.
 * Absolute URLs are accepted only when their origin matches the page origin,
 * and only the path is returned.
 */
export function toSameOriginPath(url, origin) {
  if (!url || typeof url !== "string") return null;
  const trimmed = url.trim();
  if (!trimmed || trimmed.startsWith("//") || trimmed.includes("\\")) return null;

  const pageOrigin =
    origin || (typeof window !== "undefined" ? window.location.origin : "");

  if (trimmed.startsWith("/")) {
    if (trimmed.includes("://")) return null;
    return trimmed;
  }

  if (!pageOrigin) return null;
  try {
    const parsed = new URL(trimmed);
    if (parsed.origin !== pageOrigin) return null;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return null;
  }
}
